export default () => ({
  withBatchComments: true,
  isDraftsFetched: false,
  drafts: [],
  isPublishing: false,
  currentlyPublishingDrafts: [],
  shouldAnimateReviewButton: false,
  reviewBarRendered: false,
});
